import React, { useEffect, useMemo, useState, useCallback } from 'react';
import Cookies from 'js-cookie';
import { loadPlaceBanner } from '../../../../services/services/AdsService';
import { Section } from '../../../main/Section';
import PromoCard from '../../PromoCard';
import { isEmpty } from '../../../../services/utils/utils';
import useBreakpoint from "../../../../hooks/useBreakpoint";
import { analyticsBannerClick, analyticsBannerLoad, analyticsBannerShow, ItemVariant } from '../../../../services/analytics/analyticsBanners';
import mediaQueries from '../../../../assets/styles/mediaqueries.scss';
var mobileMedia = mediaQueries.mobileMedia, tabletMedia = mediaQueries.tabletMedia, desktopMedia = mediaQueries.desktopMedia;
var queries = {
    MOBILE: mobileMedia,
    TABLET: tabletMedia,
    DESKTOP: desktopMedia
};
var PromoBanner = function (_a) {
    var _b = _a.lang, lang = _b === void 0 ? 'ru' : _b, _c = _a.title, title = _c === void 0 ? '' : _c;
    var _d = useState({}), banner = _d[0], setBanner = _d[1];
    var platform = useBreakpoint({ queries: queries, resultType: 'SHORT' });
    var ecomParamsForGA = useMemo(function () {
        return [{
                item_id: (banner === null || banner === void 0 ? void 0 : banner.code) || '',
                item_name: 'banner',
                item_variant: ItemVariant.promo,
                location_id: 's7_main'
            }];
    }, [banner]);
    var onClickBanner = useCallback(function () {
        analyticsBannerClick(ecomParamsForGA);
    }, [banner]);
    var inView = function () {
        setTimeout(function () {
            analyticsBannerShow(ecomParamsForGA);
        }, 2000);
    };
    useEffect(function () {
        if (isEmpty(banner)) {
            return;
        }
        analyticsBannerLoad(ecomParamsForGA);
    }, [banner]);
    useEffect(function () {
        var options = {
            lang: lang,
            place: 'PROMO_BANNER',
            ssdkl: Cookies.get('ssdkl')
        };
        loadPlaceBanner(options)
            .then(function (data) {
            if (!data || !Array.isArray(data) || data.length === 0) {
                return;
            }
            setBanner(data[0]);
        }).catch(function (e) { return console.log(e); });
    }, []);
    if (isEmpty(banner)) {
        return React.createElement(React.Fragment, null);
    }
    var image = banner.image, linkText = banner.linkText, subTitle = banner.subTitle, imageMobile = banner.imageMobile, imageTablet = banner.imageTablet, link = banner.link;
    var imageID = platform === 'MOBILE' && imageMobile ?
        imageMobile : platform === 'TABLET' && imageTablet
        ? imageTablet : image;
    return (React.createElement(Section, { title: title, openInNewTab: true, inView: inView },
        React.createElement(PromoCard, { title: banner.title, description: subTitle, img: imageID, buttonText: linkText, href: link, onClick: onClickBanner })));
};
export default React.memo(PromoBanner);
